import Marionette from "../../../shared/marionette-mustache";
import { LegislationRelationModel } from "../../../desktop/models/legislation-relation";
import { backboneViewProperties } from "../../../decorators/backbone-properties";

const template = require<string>("../../../desktop/views/partials/category-legislation-relation.html");

@backboneViewProperties({
    tagName: "ul",
    template
})
export class CategoryLegislationRelationView extends Marionette.ItemView<LegislationRelationModel> {
    constructor(options?: Backbone.ViewOptions<LegislationRelationModel>) {
        super(options);
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/desktop/views/partials/category-legislation-relation.ts